export const getSpaceType = (spaceKey: string | undefined): string => {
	return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
